"use client";

import { useState, useEffect } from "react";
import ClientsCarousel from "./ClientsCarousel";
import { supabase } from "@/lib/supabase";

const Clients = () => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchClients = async () => {
      const { data, error } = await supabase
        .from('Client')
        .select('id, name, logoUrl')
        .order('createdAt', { ascending: false });
      
      if (!error && data) {
        setClients(data as any);
      }
      setLoading(false);
    };
    fetchClients();
  }, []);

  if (loading || clients.length === 0) return null;

  return <ClientsCarousel clients={clients} />;
};

export default Clients;
